export const debounce =
	(fn, wait = 3000, time) =>
	(...args) => {
		clearTimeout(time, (time = setTimeout(() => fn(...args), wait)));
	};
